import { render, staticRenderFns } from "./Reserve.vue?vue&type=template&id=0f4d80b6&scoped=true&"
import script from "./Reserve.vue?vue&type=script&lang=js&"
export * from "./Reserve.vue?vue&type=script&lang=js&"
import style0 from "./Reserve.vue?vue&type=style&index=0&id=0f4d80b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4d80b6",
  null
  
)

export default component.exports